import { hmapPathParamConfig, hmapPathParamRegex } from "@ngmodules/hmap/hmap.routes";
export const ManageCarriPositionsRoutes = [
    {
        "url": `/settings/${hmapPathParamRegex}?activeTab&subTab`,
        "params": {
            ...hmapPathParamConfig
        },
        "name": "appLayout.harriSH.access-portal.settings.main",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/carri/manage-carri-positions/manage-carri-positions.downgrade.module");
                }
            },
        ],
        "route_styles": {
            framework: "bootstrap_v4"
        }
    },
    {
        "url": "/:view?tab",
        "name": "appLayout.harriSH.settings.brandSection",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("@ngmodules/carri/manage-carri-positions/manage-carri-positions.downgrade.module");
                }
            }
        ]
    },
];
//# sourceMappingURL=manage-carri-positions.routes.js.map